'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markMessage = exports.getMessage = exports.getMessagesWithStatus = exports.getMessages = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = require('./utils');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ft2tg = function ft2tg(message) {
  return _extends({}, message, {
    Provider: 'fasttrack',
    Id: message.MessageId,
    Content: message.Message,
    Status: message.IsRead ? 'Read' : 'Unread',
    StartDate: message.Date,
    Attributes: _extends({}, message.Data, {
      ctaTranslationKey: message.CTAButtonText,
      ctaAction: message.CTAButtonLink
    })
  });
};

var getMessages = exports.getMessages = function getMessages(a, b) {
  return getMessagesWithStatus(a, b);
};

var getMessagesWithStatus = exports.getMessagesWithStatus = function getMessagesWithStatus(sessionId) {
  return new Promise(function (resolve, reject) {
    var g = window || global || {};

    (0, _utils.getFastTrackSid)(sessionId).then(function (sid) {
      (0, _utils.getFastTrackToken)(sid).then(function (authtoken) {
        (0, _axios2.default)({
          method: 'get',
          url: g.fastTrackAPIHost + '/Notifications/v2/user-notifications',
          headers: {
            authtoken: authtoken
          }
        }).then(function (res) {
          if (!res.data.Success) {
            console.error('Error', res);
            return reject();
          }

          return resolve({ data: res.data.Data.map(ft2tg) });
        });
      });
    });
  });
};

var getMessage = exports.getMessage = function getMessage(sessionId) {
  return new Promise(function (resolve, reject) {
    var g = window || global || {};

    (0, _utils.getFastTrackSid)(sessionId).then(function (sid) {
      (0, _utils.getFastTrackToken)(sid).then(function (authtoken) {
        (0, _axios2.default)({
          method: 'get',
          url: g.fastTrackAPIHost + '/Notifications/v2/user-notification/' + messageID,
          headers: {
            authtoken: authtoken
          }
        }).then(function (res) {
          if (!res.data.Success) {
            console.error('Error', res);
            return reject();
          }

          return resolve(ft2tg(res.data.Data));
        });
      });
    });
  });
};

var markMessage = exports.markMessage = function markMessage(sessionId, data) {
  return new Promise(function (resolve, reject) {
    var g = window || global || {};

    (0, _utils.getFastTrackSid)(sessionId).then(function (sid) {
      (0, _utils.getFastTrackToken)(sid).then(function (authtoken) {
        (0, _axios2.default)({
          method: 'post',
          url: g.fastTrackAPIHost + '/Notifications/MarkNotificationAsRead',
          data: data,
          headers: {
            authtoken: authtoken
          }
        }).then(function (res) {
          if (!res.data.Success) {
            console.error('Error', res);
            return reject(res);
          }

          return resolve(res);
        });
      });
    });
  });
};

exports.default = {
  getMessages: getMessages,
  getMessagesWithStatus: getMessagesWithStatus,
  getMessage: getMessage,
  markMessage: markMessage
};